export default __webpack_public_path__ + "static/media/img-0478-bulgaria-premium-face.d3040af6.png";